<a mat-list-item [ngStyle]="{'padding-left': (depth * 5) + 'px'}" (click)="onItemSelected(item)"
  [ngClass]="{'active': item.route ? router.isActive(item.route, true): false, 'expanded': expanded}"
  class="menu-list-item">


  <span *ngIf="item.type=='File' && item.id">
    <svg class="dds__svg-icons customSvg" aria-hidden="true">
      <use xlink:href="#dds__doc-lines" />
    </svg>
  </span>
  <span *ngIf="item.type=='Folder' && item.id">
    <svg class="dds__svg-icons customSvg" aria-hidden="true">
      <use xlink:href="#dds__folder" />
    </svg>
  </span>
  <span *ngIf="!item.id && item.displayName=='Home'">
    <svg class="dds__svg-icons customSvg" aria-hidden="true">
      <use xlink:href="#dds__home" />
    </svg>
  </span>
  <span *ngIf="!item.id && item.displayName=='Dashboard'">
    <svg class="dds__svg-icons customSvg" aria-hidden="true">
      <use xlink:href="#dds__dashboard" />
    </svg>
  </span>

  <span matTooltip="{{item.displayName}}" matTooltipPosition="right" aria-label="Description"
    class="displayName">{{trimName(item.displayName)}}</span>

  <span *ngIf="item.children && item.children.length">

    <span class="icons">
      <svg  [@indicatorRotate]="expanded ? 'expanded': 'collapsed'" class="dds__svg-icons" aria-hidden="true"  style=" width: 20px;height:20px;padding: 5px;color: #0076CE;">
        <use xlink:href="#dds__chevron-down" />
      </svg>


    </span>
  </span>
  <span class="options" *ngIf="item.id">

    <span *ngIf="(RoleName== Moderator || RoleName==Publisher) && item.type=='Folder' && item.active"  matTooltip="New File"
    matTooltipPosition="right" aria-label="Description" class="routeIcon" (click)="onIconClick('new_file',item)">
      <svg class="dds__svg-icons customToolbarSvg" aria-hidden="true">
        <use xlink:href="#dds__doc-add" />
      </svg>
    </span>
   <span *ngIf="item.type=='Folder'"> 
    <span  *ngIf="(RoleName==Moderator || (RoleName==Publisher &&  ((item | isFolderContainsPublishedArticle)) )) && item.active" matTooltip="Edit" matTooltipPosition="right"
    aria-label="Description" class="routeIcon" (click)="onIconClick('edit',item)">
      <svg class="dds__svg-icons customToolbarSvg" aria-hidden="true">
        <use xlink:href="#dds__pencil" />
      </svg>
    </span>
   </span> 
  <span *ngIf="item.type=='File'">
    <span  *ngIf="(RoleName==Moderator || (RoleName==Publisher && (item.status===Drafted || item.status===''))) && item.active" matTooltip="Edit" matTooltipPosition="right"
    aria-label="Description" class="routeIcon" (click)="onIconClick('edit',item)">
      <svg class="dds__svg-icons customToolbarSvg" aria-hidden="true">
        <use xlink:href="#dds__pencil" />
      </svg>
    </span>
  </span> 
    <span *ngIf="RoleName==Moderator  && item.active" matTooltip="Delete" matTooltipPosition="right"
    aria-label="Description" class="routeIcon" (click)="onIconClick('delete',item)">
      <svg class="dds__svg-icons customToolbarSvg" aria-hidden="true">
        <use xlink:href="#dds__trash" />
      </svg>
    </span>
    <span *ngIf="RoleName==Moderator  && !item.active" matTooltip="Restore" matTooltipPosition="right"
          aria-label="Description" class="routeIcon" (click)="onIconClick('restore',item)">
      <svg class="dds__svg-icons customToolbarSvg" aria-hidden="true">
        <use xlink:href="#dds__reset" />
      </svg>
    </span>
  </span>
</a>

<div *ngIf="expanded && (RoleName==Moderator||RoleName==Publisher)">
  <app-menu-list-item *ngFor="let child of item.children" [item]="child" [depth]="depth+1" cdkDragBoundary=".mat-nav-list" cdkDrag>
  </app-menu-list-item>
</div>
<div *ngIf="expanded && RoleName!=Moderator && RoleName!=Publisher">
  <app-menu-list-item *ngFor="let child of item.children" [item]="child" [depth]="depth+1">
  </app-menu-list-item>
  <!-- {{item | json}} -->
</div>
